import { Flex, IconButton, Text } from '@chakra-ui/react';
import { ReactComponent as LeftArrowIcon } from 'assets/icons/carousel_arrow_left.svg';
import { useTranslation } from 'react-i18next';

import { ShareTabs, shareTabs } from './SharePanel.config';
import { SharePrivateLinkTab } from './SharingTabs/SharePrivateLinkTab';
import { ShareResponsiveLinkTab } from './SharingTabs/ShareResponsiveLinkTab';

type SharePanelTabsProps = {
  tabId: ShareTabs;
  changeTab: (tabId: ShareTabs | null) => void;
  onCopyPrivateLink?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  onCopyCurrentLink?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  onCopyResponsiveLink?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
};

export const SharePanelTabs = ({
  tabId,
  changeTab,
  onCopyPrivateLink = () => {},
  onCopyResponsiveLink = () => {},
}: SharePanelTabsProps) => {
  const { t } = useTranslation('common_navbar');
  const selectedTab = shareTabs[tabId];

  const returnToShare = () => {
    changeTab(null);
  };

  return (
    <Flex flexDir='column' gap='2' data-testid={'share-panel-tabs'}>
      <Flex flexDir='column'>
        <Flex alignItems={'center'} h={30} mb={2}>
          <IconButton
            variant='ghost'
            size={'xs'}
            icon={<LeftArrowIcon />}
            aria-label={t('modals.share-panel.sharing.back-to-list')}
            onClick={returnToShare}
            autoFocus={true}
          />
          <Text as='h2' ml={2} fontSize='sm' color='font.500' fontWeight='semibold'>
            {t(`modals.share-panel.sharing.${`${selectedTab.title.toString()}`}` as keyof typeof t)}
          </Text>
        </Flex>
        <Text ml={2} fontSize='sm' color='font.500' pb={6}>
          {t(`modals.share-panel.sharing.${`${selectedTab.description.toString()}`}` as keyof typeof t)}
        </Text>
        {tabId === ShareTabs.privateLink && <SharePrivateLinkTab onCopyLink={onCopyPrivateLink} />}
        {tabId === ShareTabs.secure && <ShareResponsiveLinkTab onCopyLink={onCopyResponsiveLink} />}
      </Flex>
    </Flex>
  );
};
